/*
 * Živá informace o expedici — reaguje na denní dobu, víkend a státní svátky.
 *
 * Proč v JavaScriptu a ne v Liquidu: Liquid se vyhodnotí při renderu na serveru
 * a Shopify stránky cachuje, takže hláška by se „zasekla" na čase, kdy se stránka
 * poprvé vygenerovala — po 10:00 by pořád tvrdila „odesíláme ještě dnes".
 * Skript počítá vždy z aktuálního času a natvrdo v pásmu Europe/Prague.
 *
 * Bez JS zůstane obecná věta ze šablony, která platí vždy. Nikdy neslíbíme
 * konkrétní den, který bychom nemuseli splnit.
 *
 * Logika je oddělená od DOMu (funkce `zprava`) záměrně, aby šla otestovat na
 * konkrétních datech bez prohlížeče — svátky a přelomy dne jsou přesně to,
 * co se špatně ověřuje okem. Testy: test/expedice.test.js
 *
 * Podporované trhy: CZ a SK. Jinde se skript vědomě neaktivuje — maďarské,
 * rumunské a slovinské svátky jsou jiné a slibovat podle českého kalendáře
 * by bylo horší než obecná věta.
 */
(function (root) {
  'use strict';

  /* Dny včetně předložky. Ta se nedá připojit zvlášť: před „středu" a „čtvrtek"
     se říká „ve", jinde „v". Skloňování se navíc liší podle vazby —
     „expedujeme VE STŘEDU" × „objednejte DO STŘEDY". */
  var L = {
    cs: {
      dnyV:  ['v neděli', 'v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu'],
      dnyDo: ['do neděle', 'do pondělí', 'do úterý', 'do středy', 'do čtvrtka', 'do pátku', 'do soboty'],
      mesice: ['ledna', 'února', 'března', 'dubna', 'května', 'června',
               'července', 'srpna', 'září', 'října', 'listopadu', 'prosince'],
      dnesHead: function (c) { return 'Objednejte do ' + c + ':00 a expedujeme ještě dnes'; },
      dnesSub:  function (h, m) { return 'Zbývá ' + (h > 0 ? h + ' h ' + m + ' min' : m + ' min'); },
      zitraHead: 'Expedujeme zítra',
      zitraSubPo: function (c) { return 'Dnešní uzávěrka v ' + c + ':00 už minula. Objednejte zítra do ' + c + ':00.'; },
      zitraSubVolno: 'Objednávejte klidně teď, odešleme hned zítra ráno.',
      pozdejiHead: function (d) { return 'Expedujeme ' + d; },
      pozdejiSub: function (d, c) { return 'Objednejte ' + d + ' ' + c + ':00. Objednávky přijímáme nonstop.'; },
      doruceni: function (d) { return 'U vás obvykle ' + d; },
      hlavni: function (d) { return 'U vás obvykle ' + d; },
      radekDnes: function (c, h, m) { return 'Objednejte do ' + c + ':00 — zbývá ' + (h > 0 ? h + ' h ' + m + ' min' : m + ' min'); },
      radekZitraPo: function (c) { return 'Uzávěrka v ' + c + ':00 už minula, expedujeme zítra.'; },
      radekZitraVolno: 'Expedujeme hned zítra ráno.',
      radekPozdeji: function (d) { return 'Expedujeme ' + d + '.'; }
    },
    sk: {
      dnyV:  ['v nedeľu', 'v pondelok', 'v utorok', 'v stredu', 'vo štvrtok', 'v piatok', 'v sobotu'],
      dnyDo: ['do nedele', 'do pondelka', 'do utorka', 'do stredy', 'do štvrtka', 'do piatku', 'do soboty'],
      mesice: ['januára', 'februára', 'marca', 'apríla', 'mája', 'júna',
               'júla', 'augusta', 'septembra', 'októbra', 'novembra', 'decembra'],
      dnesHead: function (c) { return 'Objednajte do ' + c + ':00 a expedujeme ešte dnes'; },
      dnesSub:  function (h, m) { return 'Zostáva ' + (h > 0 ? h + ' h ' + m + ' min' : m + ' min'); },
      zitraHead: 'Expedujeme zajtra',
      zitraSubPo: function (c) { return 'Dnešná uzávierka o ' + c + ':00 už minula. Objednajte zajtra do ' + c + ':00.'; },
      zitraSubVolno: 'Objednávajte pokojne teraz, odošleme hneď zajtra ráno.',
      pozdejiHead: function (d) { return 'Expedujeme ' + d; },
      pozdejiSub: function (d, c) { return 'Objednajte ' + d + ' ' + c + ':00. Objednávky prijímame nonstop.'; },
      doruceni: function (d) { return 'U vás zvyčajne ' + d; },
      hlavni: function (d) { return 'U vás zvyčajne ' + d; },
      radekDnes: function (c, h, m) { return 'Objednajte do ' + c + ':00 — zostáva ' + (h > 0 ? h + ' h ' + m + ' min' : m + ' min'); },
      radekZitraPo: function (c) { return 'Uzávierka o ' + c + ':00 už minula, expedujeme zajtra.'; },
      radekZitraVolno: 'Expedujeme hneď zajtra ráno.',
      radekPozdeji: function (d) { return 'Expedujeme ' + d + '.'; }
    }
  };

  /* Pevné státní svátky (M-D); pohyblivé Velikonoce se dopočítávají níž.
     Rozdíly ČR × SK: SK má navíc 6. 1., 29. 8., 1. 9., 15. 9. a 1. 11.,
     ČR má navíc 6. 7. a 28. 10. Zbytek je společný. */
  var SVATKY = {
    cs: ['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26'],
    sk: ['1-1', '1-6', '5-1', '5-8', '7-5', '8-29', '9-1', '9-15', '11-1', '11-17', '12-24', '12-25', '12-26']
  };

  /* Velikonoce (Meeus/Jones/Butcher) — Velký pátek a Velikonoční pondělí se
     každý rok posouvají, nejde je zapsat natvrdo. */
  function velikonocniNedele(rok) {
    var a = rok % 19, b = Math.floor(rok / 100), c = rok % 100;
    var d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mesic = Math.floor((h + l - 7 * m + 114) / 31);
    var den = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(rok, mesic - 1, den);
  }

  function stejnyDen(a, b) {
    return a.getFullYear() === b.getFullYear()
      && a.getMonth() === b.getMonth()
      && a.getDate() === b.getDate();
  }

  function jeSvatek(d, zeme) {
    var sez = SVATKY[zeme] || SVATKY.cs;
    if (sez.indexOf((d.getMonth() + 1) + '-' + d.getDate()) > -1) return true;
    var ne = velikonocniNedele(d.getFullYear());
    var velkyPatek = new Date(ne.getFullYear(), ne.getMonth(), ne.getDate() - 2);
    var pondeli = new Date(ne.getFullYear(), ne.getMonth(), ne.getDate() + 1);
    return stejnyDen(d, velkyPatek) || stejnyDen(d, pondeli);
  }

  function jePracovni(d, zeme) {
    var den = d.getDay();
    return den !== 0 && den !== 6 && !jeSvatek(d, zeme);
  }

  function pristiPracovni(od, zeme) {
    var d = new Date(od.getFullYear(), od.getMonth(), od.getDate());
    for (var i = 0; i < 21; i++) {
      d.setDate(d.getDate() + 1);
      if (jePracovni(d, zeme)) return d;
    }
    return d;
  }

  /* Den, kdy zásilka odejde ze skladu. */
  function denExpedice(ted, cutoff, zeme) {
    if (jePracovni(ted, zeme) && ted.getHours() < cutoff) {
      return new Date(ted.getFullYear(), ted.getMonth(), ted.getDate());
    }
    return pristiPracovni(ted, zeme);
  }

  function datum(d, t) {
    return t.dnyV[d.getDay()] + ' ' + d.getDate() + '. ' + t.mesice[d.getMonth()];
  }

  /*
   * Odhad doručení. PPL vozí 1–2 pracovní dny, typicky následující pracovní den
   * po expedici (viz /pages/doprava-a-platba). Píšeme „obvykle" — je to odhad
   * dopravce, ne závazek. Počet dnů jde přenastavit parametrem dodaciDny.
   */
  function denDoruceni(ted, cutoff, zeme, dodaciDny) {
    var d = denExpedice(ted, cutoff, zeme);
    for (var i = 0; i < (dodaciDny || 1); i++) d = pristiPracovni(d, zeme);
    return d;
  }

  function doruceni(ted, cutoff, zeme, t, dodaciDny) {
    return t.doruceni(datum(denDoruceni(ted, cutoff, zeme, dodaciDny), t));
  }

  /*
   * Jádro: z času a uzávěrky spočítá, co zákazníkovi napsat.
   * Vrací { stav, head, sub, doruceni } — bez jakéhokoli dotyku s DOMem.
   */
  function zprava(ted, cutoff, zeme, dodaciDny) {
    cutoff = cutoff || 10;
    zeme = (zeme || 'cs').toLowerCase();
    var t = L[zeme] || L.cs;

    var dor = doruceni(ted, cutoff, zeme, t, dodaciDny);

    if (jePracovni(ted, zeme) && ted.getHours() < cutoff) {
      var doUzaverky = new Date(ted.getFullYear(), ted.getMonth(), ted.getDate(), cutoff, 0, 0);
      var min = Math.max(0, Math.round((doUzaverky - ted) / 60000));
      return {
        stav: 'dnes',
        head: t.dnesHead(cutoff),
        sub: t.dnesSub(Math.floor(min / 60), min % 60),
        doruceni: dor,
        hlavni: t.hlavni(datum(denDoruceni(ted, cutoff, zeme, dodaciDny), t)),
        vedlejsi: t.radekDnes(cutoff, Math.floor(min / 60), min % 60)
      };
    }

    var dalsi = pristiPracovni(ted, zeme);
    var zitra = new Date(ted.getFullYear(), ted.getMonth(), ted.getDate() + 1);

    if (stejnyDen(dalsi, zitra)) {
      return {
        stav: 'zitra',
        head: t.zitraHead,
        sub: jePracovni(ted, zeme) ? t.zitraSubPo(cutoff) : t.zitraSubVolno,
        doruceni: dor,
        hlavni: t.hlavni(datum(denDoruceni(ted, cutoff, zeme, dodaciDny), t)),
        vedlejsi: jePracovni(ted, zeme) ? t.radekZitraPo(cutoff) : t.radekZitraVolno
      };
    }

    return {
      stav: 'pozdeji',
      head: t.pozdejiHead(datum(dalsi, t)),
      sub: t.pozdejiSub(t.dnyDo[dalsi.getDay()], cutoff),
      doruceni: dor,
      hlavni: t.hlavni(datum(denDoruceni(ted, cutoff, zeme, dodaciDny), t)),
      vedlejsi: t.radekPozdeji(datum(dalsi, t))
    };
  }

  /* Aktuální čas v Praze poskládaný zpět do Date, aby se počítalo s „nástěnným"
     časem bez ohledu na pásmo návštěvníka. */
  function tedVPraze() {
    try {
      var casti = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Prague',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(new Date());
      var o = {};
      casti.forEach(function (c) { o[c.type] = c.value; });
      var hod = parseInt(o.hour, 10);
      if (hod === 24) hod = 0; /* některé prohlížeče vrací 24 místo 0 */
      return new Date(+o.year, +o.month - 1, +o.day, hod, +o.minute, +o.second);
    } catch (e) {
      return new Date(); /* starý prohlížeč — radši lokální čas než nic */
    }
  }

  var api = {
    zprava: zprava, doruceni: doruceni, denExpedice: denExpedice,
    jeSvatek: jeSvatek, jePracovni: jePracovni, pristiPracovni: pristiPracovni,
    velikonocniNedele: velikonocniNedele, tedVPraze: tedVPraze, PODPOROVANE: Object.keys(L)
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api; /* pro testy v Node */
    return;
  }

  root.jackeryExpedice = api;

  function vykresli() {
    var boxy = document.querySelectorAll('[data-expedice]');
    if (!boxy.length) return;

    Array.prototype.forEach.call(boxy, function (box) {
      var zeme = (box.getAttribute('data-zeme') || 'cs').toLowerCase();
      if (!L[zeme]) return; /* nepodporovaný trh — necháme obecnou větu ze šablony */

      var cutoff = parseInt(box.getAttribute('data-cutoff'), 10) || 10;
      var dny = parseInt(box.getAttribute('data-dodaci-dny'), 10) || 1;
      var z = zprava(tedVPraze(), cutoff, zeme, dny);

      box.classList.remove('is-dnes', 'is-zitra', 'is-pozdeji');
      box.classList.add('is-' + z.stav);

      var nastav = function (sel, text) {
        var el = box.querySelector(sel);
        if (el) el.textContent = text || '';
      };
      nastav('[data-expedice-head]', z.head);
      nastav('[data-expedice-sub]', z.sub);
      nastav('[data-expedice-doruceni]', z.doruceni);

      /* Teprve teď se ukáže cesta zásilky a schová se obecná věta —
         bez JS by v ní zůstaly prázdné popisky. */
      var telo = box.querySelector('[data-exped-telo]');
      var nahrada = box.querySelector('[data-exped-nahrada]');
      if (telo) telo.hidden = false;
      if (nahrada) nahrada.hidden = true;
    });
  }

  function start() {
    vykresli();
    /* Přepočet po minutě — ať odpočet nestojí a hláška se sama přepne,
       jakmile uzávěrka uplyne. */
    setInterval(vykresli, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})(typeof window !== 'undefined' ? window : this);
